import React, { forwardRef } from 'react';
import { View } from 'react-native';
import { Stack, StackProps } from '../Stack/Stack';

export type RowProps = Omit<StackProps, 'direction'>;

export const Row = forwardRef<View, RowProps>((props, ref) => {
  return <Stack direction="row" ref={ref} {...props} />;
});
